<template>
    <div class="bg-white mt-3 p-3 activity-type-create customer-agent-view col-12">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-4">
                <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ componentName }}</span>
            </div>
        </div>
        <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="mb-3"><strong>{{ $translate('agent_id') }}</strong></label>
                    <b-form-input type="text" id="input-name" v-model="model.code"
                        placeholder="Unique Agent ID. Leave Blank for Auto Generation.." trim></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3 mt-md-0">
                    <label class="mb-3"><strong>{{
                        $translate('company_name')
                    }}</strong></label>
                    <b-form-input type="text" id="input-Company" v-model="model.company_name"
                        placeholder="Enter Agent Company Name" trim></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('first_name') }}</strong><span class="red">*</span></label>
                    <b-form-input type="text" id="input-name" v-model="model.first_name" required
                        v-custom-validation="$textRequired()" placeholder="Enter Agent First Name" trim></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('last_name') }}</strong><span class="red">*</span></label>
                    <b-form-input type="text" id="input-last-name" v-model="model.last_name" required
                        v-custom-validation="$textRequired()" placeholder="Enter Agent Last Name" trim></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('email') }}</strong><span class="red">*</span></label>
                    <b-form-input type="email" id="input-email" v-model="model.email" required v-custom-validation="$emailRequired()"
                        placeholder="Enter Agent email" trim></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('telephone') }}</strong></label>
                    <b-form-input type="tel" id="input-telephone" v-model="model.phone"
                        placeholder="Enter Agent Telephone Number" trim></b-form-input>
                </b-col>
            </b-row>
            <b-col md="12" class="mb-2 mt-5 text-center">
                <b-button class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                    variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                <b-button class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                    variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>

                <b-button v-if="this.model.id && hasPermissionDelete" @click="deleteItem()" variant="delete-button"
                    size="fw" class="me-2">
                    {{ $translate('delete_item') }}
                </b-button>
                <b-button variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                    $cancelLabel() }}</b-button>
            </b-col>
        </b-form>
    </div>
    <!-- </b-card> -->
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'customerAgents-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                code: null,
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                company_name: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        componentName() {
            return this.$translate('customer_agent')
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) {
            this.model = { ...this.item }
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },

        deleteItem() {
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'customerAgents/delete'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_customer_agent')
            const message = `${this.$translate('delete_note')} ${model.first_name + ' ' + model.last_name
                }?`
            const errorMsg = null //'Unable to delete Transaction Type!'

            this.$emit(
                'delete-item',
                title,
                message,
                model.id,
                () => {
                    this.$emit(
                        'success',
                        'deleted',
                        this.$translate('delete_alert')
                    )
                },
                path,
                errorMsg
            )
        },

        createOrUpdate() {
            this.loading = true
            const model = { ...this.model }

            console.log('model', model)
            const path = model.id
                ? 'customerAgents/update'
                : 'customerAgents/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const status = model.id
                                ? this.$translate('updated')
                                : this.$translate('created')
                            const message = model.id
                                ? this.$translate('update_alert')
                                : this.$translate('create_alert')
                            this.$emit('success', status, message)
                        })
                        .catch(error => {
                            let message = error.message
                            this.genericToast(
                                `${this.componentName}`,
                                '',
                                'danger',
                                `${message}`
                            )
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
    },
}
</script>
<style></style>
